const WordTypes = {
	GET_WORDS: 'GET_WORDS',
	GET_TOTAL_WORDS: 'GET_TOTAL_WORDS',
}

export default WordTypes
